module.exports = __webpack_public_path__ + "static/media/year2023_1-sc.859da6b2.jpg";